import React from 'react';
import style from './style.css';

import { RegisterLoginForm } from 'cccisd-laravel-nexus';

const Fortress = window.cccisd && window.cccisd.fortress;
const Boilerplate = window.cccisd.boilerplate;

export default class RegisterPage extends React.Component {
    registerProps = {
        title: 'Register',
        role: 'learner',
        showPasswordFields: true,
        isRecaptchaRequired: true,
    };

    loginProps = {
        title: 'Login',
        showPasswordToggle: true,
    };

    render() {
        return Fortress.auth() ? (
            window.location.replace(Boilerplate.url('/survey/course'))
        ) : (
            <div className={style.page}>
                <RegisterLoginForm registerProps={this.registerProps} loginProps={this.loginProps} />
            </div>
        );
    }
}
